import React from "react";
import ListBoxQueryMultiSelect from "./list_box_query";
import { Link } from "wouter";
import { TrashIcon, UserPlusIcon, ArrowUturnLeftIcon, CheckIcon } from '@heroicons/react/24/outline';
import { listEmployeesFromOrganizationalUnit } from "../services/api_org_unit";




function OrgAddEmployeeRoleHandlers({ unitData, isVisibleHandlers, selectedEmployeesHandlers, handleSelectionChangeHandlers, toggleVisibilityHandlers, handleUnselectEmployee, handleSaveHandlers, handleRemoveEmployeeOU, isSaving, token }) {
    
    const makeEmployeeFetcher = ({ token, ouId, role, pageSize = 5 }) => {
        let lastQuery = '';
        let totalPages = Infinity;

        return async (query, page) => {
            const q = (query || '').trim();

            if (q !== lastQuery) {
                lastQuery = q;
                totalPages = Infinity;
            }

            if (page > totalPages) {
                return [];
            }

            try {
                const res = await listEmployeesFromOrganizationalUnit(
                    token,
                    ouId,
                    q,
                    role,
                    page,
                    pageSize,
                    'all'
                );

                const numPages =
                    res?.num_pages ??
                    (typeof res?.count === 'number'
                    ? Math.max(1, Math.ceil(res.count / pageSize))
                    : page);

                totalPages = numPages;

                const arr = Array.isArray(res?.results) ? res.results : [];
                return arr.map(dip => ({
                    name: dip.last_name && dip.first_name ? `${dip.last_name} ${dip.first_name}` : dip.cf,
                    value: dip.id,
                    original: dip,
                }));
            } catch (e) {
                return [];
            }
        };
    };

    return (
        <div className='border border-solid-2 border-gray-200 shadow-md rounded-md my-5'>
            <div className='grid grid-cols-2 bg-gray-100 justify-between'>
                <div className='col-span-1'>
                    <h4 className='bg-gray-100 p-3 text-sm font-semibold uppercase'>Gestori dell'Unità Organizzativa</h4>
                </div>
            </div>
            {unitData.handlers?.length > 0 ? (
                <div className="max-h-[50vh] overflow-y-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th scope="col" className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider block sm:hidden sticky left-0 bg-white" style={{ width: '10%' }}></th>
                                <th scope="col" className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider" style={{ width: '30%' }}>Codice Fiscale</th>
                                <th scope="col" className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider" style={{ width: '30%' }}>Cognome</th>
                                <th scope="col" className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider" style={{ width: '30%' }}>Nome</th>
                                <th scope="col" className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider sm:block hidden" style={{ width: '10%' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {unitData.handlers
                                .slice()
                                .sort((a, b) => a.cf.localeCompare(b.cf))
                                .map((handler, index) => (
                                <tr 
                                    key={handler.id} className={index !== unitData.handlers.length - 1 ? 'border-b border-gray-200' : ''}
                                    style={handler.has_active_contract ? { backgroundColor: 'white' } : PatternInactiveEmployee()}
                                >
                                    <td className="px-1 py-2 text-sm text-left whitespace-nowrap text-gray-700 block sm:hidden sticky left-0 bg-white" style={{ width: '10%' }}>
                                        <button className="text-gray-700 font-bold px-1 bg-white" title="Elimina" onClick={() => handleRemoveEmployeeOU(handler.id)}>
                                            <TrashIcon className="h-6 w-6 hover:text-red-500" /> 
                                        </button>
                                    </td>
                                    <td className="px-3 py-2 text-sm text-left whitespace-nowrap text-gray-700 hover:underline-offset-2 hover:underline" style={{ width: '30%' }}>
                                        <Link to={`/dipendenti/${handler.cf}/`}>{handler.cf}</Link>
                                    </td>
                                    <td className="px-1 py-2 text-sm text-left whitespace-nowrap text-gray-700" style={{ width: '30%' }}>{handler.last_name}</td>
                                    <td className="px-1 py-2 text-sm text-left whitespace-nowrap text-gray-700" style={{ width: '30%' }}>{handler.first_name}</td>
                                    <td className="px-1 py-2 text-sm text-left whitespace-nowrap text-gray-700 sm:block hidden" style={{ width: '10%' }}>
                                        <button className="text-gray-700 font-bold px-1" title="Elimina" onClick={() => handleRemoveEmployeeOU(handler.id)}>
                                            <TrashIcon className="h-6 w-6 hover:text-red-500" /> 
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <p className="p-3 text-sm">Non sono presenti gestori</p>
            )}
            <div className='grid grid-cols-3 bg-gray-100 justify-between'>
                <div className='col-span-3 sm:col-span-1'> 
                    {isVisibleHandlers && (
                        <div className='p-3'>
                            <ListBoxQueryMultiSelect
                                fetchData={makeEmployeeFetcher({
                                    token,
                                    ouId: unitData?.id,
                                    role: 'handler',
                                    pageSize: 5,
                                })}
                                selectedValues={selectedEmployeesHandlers.map(dip => ({
                                    name: dip.last_name && dip.first_name ? `${dip.last_name} ${dip.first_name}` : dip.cf,
                                    value: dip.id,
                                    original: dip
                                }))}
                                onChange={handleSelectionChangeHandlers}
                                placeholder="Cerca dipendente..."
                            />
                        </div>
                    )}
                </div>
                
                {isVisibleHandlers && selectedEmployeesHandlers.length > 0 ? (
                    <div className='col-span-3 sm:col-span-1 flex items-center justify-end pe-5 py-3'>
                        <button 
                            className={`flex items-center justify-center text-gray-700 font-semibold px-1 border border-solid shadow-md w-60 hover:bg-white rounded-md ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`} 
                            title="Salva" 
                            onClick={() => handleSaveHandlers(selectedEmployeesHandlers)}
                            disabled={isSaving}
                        >
                            {isSaving ? <p className='p-2 text-sm uppercase'>Salvataggio...</p> : <p className='p-2 text-sm uppercase'>Conferma e Salva</p>}
                            <CheckIcon className="h-6 w-6 text-indigo-800" />
                        </button>
                    </div>
                ) : (
                    <div className='col-span-1'></div>
                )}
                <div className='col-span-3 sm:col-span-1 flex items-center justify-end pe-5 py-3'>
                    {!isVisibleHandlers ? (
                        <button 
                            className="flex items-center justify-center text-gray-700 font-semibold px-1 border border-solid shadow-md w-60 hover:bg-white rounded-md " 
                            title="Aggiungi" 
                            onClick={toggleVisibilityHandlers}
                        >
                            <p className='p-2 text-sm uppercase'>Aggiungi gestori</p>
                            <UserPlusIcon className="h-6 w-6 text-indigo-800" />
                        </button>
                    ) : (
                        <button 
                            className="flex items-center justify-center text-gray-700 font-semibold px-1 border border-solid shadow-md w-60 hover:bg-white rounded-md sm:ml-0 ml-3" 
                            title="Annulla" 
                            onClick={toggleVisibilityHandlers}
                        >
                            <p className='p-2 text-sm uppercase'>Annulla</p>
                            <ArrowUturnLeftIcon className="h-6 w-6 text-indigo-800" />
                        </button>
                    )}
                </div>

                {isVisibleHandlers && selectedEmployeesHandlers.length > 0 && (
                    <>
                        <div className='col-span-3 p-4 max-h-[50vh] overflow-y-auto'>
                            <table className="min-w-full divide-y divide-gray-200 bg-white">
                                <thead>
                                    <tr>
                                        <th colSpan={4} className="p-3 text-center text-sm border-b border-gray-200 font-semibold text-gray-800 uppercase tracking-wider bg-gray-50">Aggiungi Gestori</th>
                                    </tr>
                                    <tr className="bg-gray-50">
                                        <th className="text-left text-xs font-medium text-gray-800 uppercase tracking-wider bg-gray-50 sticky left-0 z-10" style={{ width: '10%' }}></th>
                                        <th className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider bg-gray-50" style={{ width: '30%' }}>Codice Fiscale</th>
                                        <th className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider bg-gray-50" style={{ width: '30%' }}>Cognome</th>
                                        <th className="p-3 text-left text-xs font-medium text-gray-800 uppercase tracking-wider bg-gray-50" style={{ width: '30%' }}>Nome</th>
                                        <th className="text-left text-xs font-medium text-gray-800 uppercase tracking-wider bg-gray-50 hidden sm:block" style={{ width: '10%' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedEmployeesHandlers.map((employee, index) => (
                                        <React.Fragment key={employee.id}>
                                            <tr>
                                                <td className="py-2 text-sm text-left whitespace-nowrap text-gray-700 bg-white block sm:hidden sticky left-0" style={{ width: '10%' }}>
                                                    <button className="text-gray-700 font-bold px-1 bg-white" title="Elimina" onClick={() => handleUnselectEmployee(employee.id, 'handlers')}>
                                                        <TrashIcon className="h-6 w-6 hover:text-red-500" /> 
                                                    </button>
                                                </td>
                                                <td className="px-3 py-2 text-sm text-left whitespace-nowrap text-gray-700 bg-white" style={{ width: '30%' }}>{employee.cf}</td>
                                                <td className="px-1 py-2 text-sm text-left whitespace-nowrap text-gray-700 bg-white" style={{ width: '30%' }}>{employee.last_name}</td>
                                                <td className="px-1 py-2 text-sm text-left whitespace-nowrap text-gray-700 bg-white" style={{ width: '30%' }}>{employee.first_name}</td>
                                                <td className="px-3 py-2 text-sm text-left whitespace-nowrap text-gray-700 bg-white hidden sm:block" style={{ width: '10%' }}>
                                                    <button className="text-gray-700 font-bold px-1" title="Elimina" onClick={() => handleUnselectEmployee(employee.id, 'handlers')}>
                                                        <TrashIcon className="h-6 w-6 hover:text-red-500" /> 
                                                    </button>
                                                </td>
                                            </tr>
                                            {index !== selectedEmployeesHandlers.length - 1 && <tr><td colSpan={4} className="border-t border-gray-100"></td></tr>}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
};

export default OrgAddEmployeeRoleHandlers;

const PatternInactiveEmployee = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23a5b4fc' fill-opacity='1' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};